import { SxProps, Theme } from "@mui/material/styles";

export const recorderContainerStyles = (docked = false): SxProps<Theme> => ({
  display: "flex",
  flexDirection: "column",
  gap: 1,
  width: "100%",
  p: docked ? 0 : 1.5,
  borderTop: docked ? "none" : "1px solid",
  borderColor: "divider",
});

export const recorderRowStyles: SxProps<Theme> = (theme) => ({
  position: "relative",
  display: "flex",
  alignItems: "center",
  width: "100%",
  minHeight: 52,
  borderRadius: "26px",
  backgroundColor:
    theme.palette.mode === "dark" ? "rgba(255,255,255,0.06)" : "#F3EDF7",
  border: `1px solid ${
    theme.palette.mode === "dark" ? "rgba(255,255,255,0.12)" : "#D4C4E8"
  }`,
  px: 1,
  py: 0.5,
  overflow: "visible",
});

export const recorderHintStyles: SxProps<Theme> = {
  flex: 1,
  minWidth: 0,
  pr: "56px",
  pl: 1.5,
  fontSize: "13px",
  color: "#9CA3AF",
  fontWeight: 500,
};

export const waitHintStyles: SxProps<Theme> = {
  fontSize: "12px",
  color: "#9CA3AF",
  textAlign: "center",
};

export const micActionSlotStyles = (options?: {
  locked?: boolean;
  recordingHold?: boolean;
}): SxProps<Theme> => {
  if (options?.recordingHold) {
    return {
      position: "absolute",
      right: "-6px",
      top: "50%",
      transform: "translateY(-50%)",
      width: 64,
      height: 64,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      overflow: "visible",
      zIndex: 5,
    };
  }

  if (options?.locked) {
    return {
      position: "absolute",
      right: "0px",
      top: "50%",
      transform: "translateY(-50%)",
      width: 44,
      height: 44,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      overflow: "visible",
      zIndex: 5,
    };
  }

  return {
    position: "absolute",
    right: "4px",
    top: "4px",
    bottom: "4px",
    aspectRatio: "1 / 1",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "visible",
    zIndex: 5,
  };
};

export const micActionInnerStyles: SxProps<Theme> = {
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  overflow: "visible",
};

export const uploadingOverlayStyles: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 1,
  borderRadius: "26px",
  backgroundColor: "rgba(255,255,255,0.72)",
  zIndex: 10,
};
